import React from "react";
import { useParams } from "react-router-dom";

import Page from "../../components/Page";
import SchoolForm from "../../components/sections/school/SchoolForm";

const School = () => {
  const { id } = useParams();
  const title = id ? "Edit school" : "Add school";

  const breadcrumb = [
    {
      path: "/",
      breadcrumbName: "Home",
    },
    {
      path: "/schools",
      breadcrumbName: "Schools",
    },
    {
      path: "",
      breadcrumbName: title,
    },
  ];
  return (
    <>
      <Page title={title} breadcrumb={breadcrumb}>
        <div className="page-container">
          <div className="page-padding-leftRight page-padding-topBottom">
            <SchoolForm />
          </div>
        </div>
      </Page>
    </>
  );
};

export default School;
